export default function SvgUserEditIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M7.5 12.917H6.25c-1.163 0-1.744 0-2.217.143a3.333 3.333 0 00-2.222 2.222c-.144.473-.144 1.055-.144 2.218M12.084 6.25a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM9.167 17.5l2.585-.738c.123-.036.185-.053.243-.08a.831.831 0 00.145-.085c.051-.038.097-.084.188-.175l5.38-5.38a1.473 1.473 0 00-2.083-2.084l-5.38 5.381a1.753 1.753 0 00-.175.188.84.84 0 00-.085.145c-.027.058-.044.12-.08.243L9.167 17.5z"
      ></path>
    </svg>
  )
}
